import {
  GET_USER_FITBIT_LOGS_BY_ID,
  GET_USER_FITBIT_LOGS_BY_ID_SUCCESS,
  GET_USER_FITBIT_LOGS_BY_ID_ERROR,
  GET_USER_NUTRITION_BY_ID,
  GET_USER_NUTRITION_BY_ID_SUCCESS,
  GET_USER_NUTRITION_BY_ID_ERROR,
  GET_USER_NUTRITION_PREFERENCE_BY_ID,
  GET_USER_NUTRITION_PREFERENCE_BY_ID_SUCCESS,
  GET_USER_NUTRITION_PREFERENCE_BY_ID_ERROR,
  UPDATE_CLIENT_NUTRITION_PREFERENCES,
  UPDATE_CLIENT_NUTRITION_PREFERENCES_SUCCESS,
  UPDATE_CLIENT_NUTRITION_PREFERENCES_ERROR,
  DELETE_MEALPLAN_TEMPLATE_SUCCESS,
  UPDATE_MEALPLAN_BY_ID_SUCCESS,
  GET_MEALPLAN_BY_ID,
  GET_MEALPLAN_BY_ID_SUCCESS,
  GET_COACH_MEALPLANS,
  GET_COACH_MEALPLANS_SUCCESS,
  GET_USER_MEALPLAN_BY_ID,
  GET_USER_MEALPLAN_BY_ID_SUCCESS,
  GET_USER_MEALPLAN_BY_ID_ERROR,
  GET_CLIENT_PROFILE_BY_ID,
  GET_CLIENT_PROFILE_BY_ID_SUCCESS,
  GET_CLIENT_PROFILE_BY_ID_ERROR,
  SET_CLIENT_NUTRITION_FROM_PROFILE_UPDATE,
  SAVE_CLIENT_NUTRITION_SUCCESS,
  DELETE_CUSTOM_MEAL_PLAN,
  DELETE_CUSTOM_MEAL_PLAN_SUCCESS
} from "./constants";
import { restrictions } from '../../data/restrictions';

const initialState = {
  fitbitLogs: null,
  fitbitLogsLoading: false,
  fitbitLogsError: null,
  allUserNutrition: null,
  allUserNutritionLoading: false,
  allUserNutritionError: null,
  userNutritionPreference: null,
  userNutritionPreferenceLoading: false,
  userNutritionPreferenceError: null,
  coachMealplans: {templates: []},
  coachMealplansLoading: false,
  mealplan: null,
  mealplanLoading: false,
  userMealplan: null,
  userMealplanLoading: true,
  userMealplanError: null,
  clientProfile: null,
  clientProfileLoading: false,
  clientProfileError: null,
  nutrition: null,
  foodRestrictions: restrictions,
  clientSuggestions: [],
  clientSuggestionsLoading: false,
  clientSuggestionsError: null,
};

function admin(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_USER_FITBIT_LOGS_BY_ID:
      return {
        ...state,
        fitbitLogs: null,
        fitbitLogsLoading: true,
        fitbitLogsError: null
      };
    case GET_USER_FITBIT_LOGS_BY_ID_SUCCESS:
      return {
        ...state,
        fitbitLogs: payload,
        fitbitLogsError: false,
        fitbitLogsLoading: false,
      };
    case GET_USER_FITBIT_LOGS_BY_ID_ERROR:
      return {
        ...state,
        fitbitLogsError: action.err,
        fitbitLogsLoading: false,
      };
    case GET_USER_NUTRITION_BY_ID:
      return {
        ...state,
        allUserNutrition: null,
        allUserNutritionLoading: true,
        allUserNutritionError: null
      };
    case GET_USER_NUTRITION_BY_ID_SUCCESS:
      return {
        ...state,
        allUserNutrition: payload,
        allUserNutritionError: false,
        allUserNutritionLoading: false,
      };
    // Optimistically prepend the just-saved manual target so the
    // "Macro target" card (which reads allUserNutrition[0] via
    // deriveTargetInfo) refreshes immediately — without this the card
    // showed stale values until the next refetch since the save saga
    // only POSTs, it doesn't re-pull the list.
    case SAVE_CLIENT_NUTRITION_SUCCESS:
      return {
        ...state,
        allUserNutrition: [
          payload,
          ...(Array.isArray(state.allUserNutrition)
            ? state.allUserNutrition
            : []),
        ],
      };
    case GET_USER_NUTRITION_BY_ID_ERROR:
      return {
        ...state,
        allUserNutritionError: action.err,
        allUserNutritionLoading: false,
      };
    case GET_USER_NUTRITION_PREFERENCE_BY_ID:
      return {
        ...state,
        userNutritionPreferenceErr: false,
        userNutritionPreferenceLoading: true
      };
    case GET_USER_NUTRITION_PREFERENCE_BY_ID_SUCCESS:
      return {
        ...state,
        userNutritionPreference: payload,
        userNutritionPreferenceLoading: false
      };
    case GET_USER_NUTRITION_PREFERENCE_BY_ID_ERROR:
      return {
        ...state,
        userNutritionPreferenceLoading: false,
        userNutritionPreferenceErr: action.err
      };
    // Trainer-write update success — replace the cached
    // userNutritionPreference with the server's just-saved doc so the
    // preferences page reflects the change without a manual refetch.
    case UPDATE_CLIENT_NUTRITION_PREFERENCES:
      return {
        ...state,
        userNutritionPreferenceErr: false,
      };
    case UPDATE_CLIENT_NUTRITION_PREFERENCES_SUCCESS:
      return {
        ...state,
        userNutritionPreference: payload,
      };
    case UPDATE_CLIENT_NUTRITION_PREFERENCES_ERROR:
      return {
        ...state,
        userNutritionPreferenceErr: action.err,
      };
    case DELETE_MEALPLAN_TEMPLATE_SUCCESS:
      return {
        ...state,
        coachMealplans: {
          templates: (state.coachMealplans.templates || []).filter(i => i._id !== payload)
        }
      }
    case UPDATE_MEALPLAN_BY_ID_SUCCESS:
      return {
        ...state,
        mealplan: payload
      }
    case GET_MEALPLAN_BY_ID:
      return {
        ...state,
        mealplanLoading: true
      }
    case GET_MEALPLAN_BY_ID_SUCCESS:
      return {
        ...state,
        mealplan: payload,
        mealplanLoading: false
      }
    case GET_COACH_MEALPLANS:
      return {
        ...state,
        coachMealplans: {templates: []},
        coachMealplansLoading: true
      };
    case GET_COACH_MEALPLANS_SUCCESS:
      return {
        ...state,
        coachMealplans: payload,
        coachMealplansLoading: false
      }
    case GET_USER_MEALPLAN_BY_ID:
      return {
        ...state,
        userMealplan: null,
        userMealplanLoading: true,
        userMealplanError: null
      };
    case GET_USER_MEALPLAN_BY_ID_SUCCESS:
      return {
        ...state,
        userMealplan: {
          ...state.userMealplan,
          ...payload,
        },
        userMealplanLoading: false,
        userMealplanError: null
      }
    case GET_USER_MEALPLAN_BY_ID_ERROR:
      return {
        ...state,
        userMealplanError: action.err,
        allUserNutritionLoading: false
      }
    case GET_CLIENT_PROFILE_BY_ID:
      return {
        ...state,
        clientProfile: null,
        clientProfileLoading: true,
        clientProfileError: null
      };
    case GET_CLIENT_PROFILE_BY_ID_SUCCESS:
      return {
        ...state,
        clientProfile: payload,
        clientProfileLoading: false,
        clientProfileError: false,
      };
    case GET_CLIENT_PROFILE_BY_ID_ERROR:
      return {
        ...state,
        clientProfileLoading: false,
        clientProfileError: action.err
      };
    case SET_CLIENT_NUTRITION_FROM_PROFILE_UPDATE:
      return {
        ...state,
        nutrition: payload,
        allUserNutrition: [{...payload.nutritionResults}, ...state.allUserNutrition]
      }
    case DELETE_CUSTOM_MEAL_PLAN:
      return {
        ...state,
        userMealplanLoading: true,
        userMealplanError: null
      };
    case DELETE_CUSTOM_MEAL_PLAN_SUCCESS:
      return {
        ...state,
        userMealplan: {...state.userMealplan, customMealPlan: null},
        userMealplanLoading: false,
        userMealplanError: null
      };
    case 'admin/GET_CLIENT_SUGGESTIONS':
      return {
        ...state,
        clientSuggestionsLoading: true,
        clientSuggestionsError: null,
      };
    case 'admin/GET_CLIENT_SUGGESTIONS_SUCCESS':
      return {
        ...state,
        clientSuggestions: Array.isArray(payload) ? payload : [],
        clientSuggestionsLoading: false,
        clientSuggestionsError: null,
      };
    case 'admin/GET_CLIENT_SUGGESTIONS_ERROR':
      return {
        ...state,
        clientSuggestionsLoading: false,
        clientSuggestionsError: action.err,
      };
    default:
      return state;
  }
}

export default admin;